import {
    ConfigViewType,
    ItemListView,
    NodeTypeName
} from "@app/types";
import BaseNodeModel from "../BaseNodeModel";

export default class ReportNodeModel extends BaseNodeModel {
    /**
     * Report node model
     * @module ReportNodeModel
     * @param {string} nodeName Node display name
     * @param {number} x Node x coordinate on canvas
     * @param {number} y Node y coordinate on canvas
     * @param {Object} props Pre-defined node properties; if non-null, apply values to node properties
     * @param {string} id If non-null, use this ID as the node ID
     */
    constructor(nodeName = "UNTITLED_NODE", x = 0, y = 0, props = null, id = null) {
        super(nodeName, x, y, null, id);
        this.props.nodeTypeName = NodeTypeName.report;
        this.props.colorClass = "brown";
        this.props.iconClass = "activity";
        this.DEFAULT_COLOR_CLASS = "brown";
        this.applyProps(props);
    }

    // TODO: UsedIn
    setConfig(key, value) {
        this.props.config[key] = value;
        super.setConfig(key, value);
    }
    getConfigViews() {
        const configView = [

            { type: "Input", suggestion: "variable", label: this.getPropLabel("transfer_reason"), key: "transferReason", hint: this.getPropLabel("transfer_reason_hint") },
            { type: "Input", suggestion: "variable", label: this.getPropLabel("transfer_destination"), key: "transferDestination", hint: this.getPropLabel("transfer_destination_hint") },

            { type: "KeySwitch", key: "text" },
            {
                type: "KeyValue", key: "billing",
                pairKeyView: {
                    key: "key", 
                    type: "Dropdown", 
                    optionName: this.getPropLabel("type"),
                    disabled: this.props.isCommonModule,
                    options: [{ name: "None", value: "NONE" }, { name: "Start", value: "START" }, { name: "End", value: "END" }, { name: "Failed", value: "FAILED" }],
                    defaultKeyIndex: 0

                },
                pairValueView: { 
                    key: "value",
                    type: "Input", 
                    suggestion: "variable", 
                    disabled: this.props.isCommonModule,
                    hint: this.getPropLabel("type"),
                    resetKeyOnValueCleared: true
                }

            },
            {
                type: "KeyValue", label: this.getPropLabel("custom_tag"), key: "customTag",
                pairKeyView: { type: "Input", key: "key", hint: this.getPropLabel("type"),disabled: this.isCommonModule},
                pairValueView: { type: "Input", suggestion: "variable", key: "value", hint: this.getPropLabel("type"),disabled: this.isCommonModule}
            },
            { type: "Input", suggestion: "variable", label: this.getPropLabel("script_progress"), key: "scriptProgress", hint: this.getPropLabel("script_progress_hint") }
        ];

        return [
            ...this.getConfigViewNameField(),
            ...[
                { type: "Textarea", label: this.getPropLabel("description"), key: "description" },
                { type: ConfigViewType.oldItemList, label: this.getPropLabel("inputs"), key: "inputs", view: ItemListView.argument },
                { type: ConfigViewType.oldItemList, label: this.getPropLabel("outputs"), key: "outputs", view: ItemListView.return }
            ],
            ...configView,
            ...[
                { type: "hr" },
                { type: "Textarea", label: this.getPropLabel("note"), key: "note" }
            ]
        ];
    }
}